module.exports = __webpack_public_path__ + "static/media/add.9ee8007e.svg";